import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-navtoggle', 'toggleMenu', 'Lülitage menüü sisse');
Labels.set('ui-navtoggle', 'closeMenu', 'Sulge menüü');
Labels.set('ui-navtoggle', 'close', 'Sulge');
